import { network } from '@utils';
import { createAsyncThunk } from '@store';

import { keys } from './RecommendedModules.keys';
import { RecommendedModulesPayload } from './RecommendedModules.schema';

export const get = createAsyncThunk('recommendedModules/get', (deploymentId: number, { signal }) =>
  network.get<RecommendedModulesPayload>({ key: keys.get, params: { deployment: deploymentId } }, { signal }),
);
